import _extends from 'babel-runtime/helpers/extends';
export var LOAD_RESOURCE_FROM_PUDDLE = 'LOAD_RESOURCE_FROM_PUDDLE';
export var LOAD_DECRYPTION_KEYS = 'LOAD_DECRYPTION_KEYS';
export var DECRYPTION_KEYS_LOADED = 'DECRYPTION_KEYS_LOADED';

var ADD_RESOURCE_LOADED_FROM_PUDDLE = 'ADD_RESOURCE_LOADED_FROM_PUDDLE';
var RESET_MEDIA_STATE = 'RESET_MEDIA_STATE';
var INITIALIZE_MEDIA_LIB = 'INITIALIZE_MEDIA_LIB';
var MEDIA_ERROR = 'MEDIA_ERROR';
var START_RECORDER_RECORDING = 'START_RECORDER_RECORDING';
var STOP_RECORDER_RECORDING = 'STOP_RECORDER_RECORDING';

export var SIGN_URI = 'SIGN_URI';
var URI_SIGNED = 'URI_SIGNED';
var URI_EXPIRED = 'URI_EXPIRED';
var URI_VALIDATED = 'URI_VALIDATED';

var initialMediaState = {
  puddleResources: {},
  signedUris: {},
  decryptionKeys: null,
  apolloClient: undefined,
  isRecording: false,
  isWebi: false,
  contentFont: 'Effra, "Helvetica Neue", Helvetica, Arial, sans-serif',
  errorHandler: undefined
};

export var mediaReducer = function mediaReducer() {
  var mediaState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMediaState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  switch (action && action.type) {
    // here for those actions which only want saga side effects
    case LOAD_RESOURCE_FROM_PUDDLE:
      return mediaState;

    // actions which need the apollo client
    case LOAD_DECRYPTION_KEYS:
    case SIGN_URI:
      {
        action.payload.apolloClient = mediaState.apolloClient;
        return mediaState;
      }

    case ADD_RESOURCE_LOADED_FROM_PUDDLE:
      var newResources = _extends({}, mediaState.puddleResources);
      newResources[action.payload.resourceId] = action.payload.resourceUri;
      return _extends({}, mediaState, {
        puddleResources: newResources
      });

    case DECRYPTION_KEYS_LOADED:
      // decryptionKeys comes as an array of keys with ids
      //  store as a hash from the key id to the key itself
      var keysHash = {};
      action.payload.decryptionKeysArray.forEach(function (keyObject) {
        keysHash[keyObject.id] = keyObject.key;
      });
      return _extends({}, mediaState, {
        decryptionKeys: keysHash
      });

    case URI_SIGNED:
      {
        var returnState = _extends({}, mediaState);
        var currentSignedUri = mediaState.signedUris[action.payload.key] || {};
        returnState.signedUris[action.payload.key] = _extends({}, currentSignedUri, {
          uri: action.payload.data.signUri
        });
        return returnState;
      }
    case URI_VALIDATED:
      {
        var _returnState = _extends({}, mediaState);
        var _currentSignedUri = mediaState.signedUris[action.payload.key] || {};
        _returnState.signedUris[action.payload.key] = _extends({}, _currentSignedUri, {
          invalid: false
        });
        return _returnState;
      }
    case URI_EXPIRED:
      {
        var _returnState2 = _extends({}, mediaState);
        var _currentSignedUri2 = mediaState.signedUris[action.payload.key] || {};
        _returnState2.signedUris[action.payload.key] = _extends({}, _currentSignedUri2, {
          invalid: true
        });
        return _returnState2;
      }

    // reset everything except the initialization things
    case RESET_MEDIA_STATE:
      return _extends({}, mediaState, {
        puddleResources: {},
        signedUris: {},
        decryptionKeys: null,
        isRecording: false
      });

    case INITIALIZE_MEDIA_LIB:
      var newState = _extends({}, mediaState, {
        isWebi: action.payload.isWebi,
        apolloClient: action.payload.apolloClient,
        errorHandler: action.payload.errorHandler
      });
      if (action.payload.contentFont) {
        newState.contentFont = action.payload.contentFont;
      }
      return newState;

    case START_RECORDER_RECORDING:
      if (mediaState.isRecording) {
        return mediaState;
      }
      return _extends({}, mediaState, {
        isRecording: true
      });

    case STOP_RECORDER_RECORDING:
      if (!mediaState.isRecording) {
        return mediaState;
      }
      return _extends({}, mediaState, {
        isRecording: false
      });

    case MEDIA_ERROR:
      if (mediaState.errorHandler) {
        mediaState.errorHandler(action.payload);
      }
      return mediaState;

    default:
      return mediaState;
  }
};

export var mediaActions = {
  initializeMediaLib: function initializeMediaLib(_ref) {
    var apolloClient = _ref.apolloClient,
        isWebi = _ref.isWebi,
        contentFont = _ref.contentFont,
        errorHandler = _ref.errorHandler;
    return {
      type: INITIALIZE_MEDIA_LIB,
      payload: { apolloClient: apolloClient, isWebi: isWebi, contentFont: contentFont, errorHandler: errorHandler }
    };
  },
  loadResourceFromPuddle: function loadResourceFromPuddle(resourceId) {
    return { type: LOAD_RESOURCE_FROM_PUDDLE, payload: { resourceId: resourceId } };
  },
  addResourceLoadedFromPuddle: function addResourceLoadedFromPuddle(resourceId, resourceUri) {
    return {
      type: ADD_RESOURCE_LOADED_FROM_PUDDLE,
      payload: { resourceId: resourceId, resourceUri: resourceUri }
    };
  },
  loadDecryptionKeys: function loadDecryptionKeys() {
    return { type: LOAD_DECRYPTION_KEYS, payload: { apolloClient: null } };
  },
  decryptionKeysLoaded: function decryptionKeysLoaded(decryptionKeysArray) {
    return {
      type: DECRYPTION_KEYS_LOADED,
      payload: { decryptionKeysArray: decryptionKeysArray }
    };
  },
  signUri: function signUri(key) {
    return { type: SIGN_URI, payload: { key: key, apolloClient: null } };
  },
  uriSigned: function uriSigned(key, data) {
    return { type: URI_SIGNED, payload: { key: key, data: data } };
  },
  setUriValidated: function setUriValidated(key) {
    return { type: URI_VALIDATED, payload: { key: key } };
  },
  setUriExpired: function setUriExpired(key) {
    return { type: URI_EXPIRED, payload: { key: key } };
  },
  startRecorderRecording: function startRecorderRecording() {
    return {
      type: START_RECORDER_RECORDING,
      payload: { recording: true }
    };
  },
  stopRecorderRecording: function stopRecorderRecording() {
    return {
      type: STOP_RECORDER_RECORDING,
      payload: { recording: false }
    };
  },
  resetToInitialState: function resetToInitialState() {
    return { type: RESET_MEDIA_STATE };
  },
  handleError: function handleError(errorStr, params) {
    return {
      type: MEDIA_ERROR,
      payload: { message: errorStr, params: params }
    };
  }
};

export var mediaSelectors = {
  getLoadedResource: function getLoadedResource(state, resourceId) {
    return state.media.puddleResources[resourceId];
  },
  getDecryptionKeys: function getDecryptionKeys(state) {
    return state.media.decryptionKeys;
  },
  isWebi: function isWebi(state) {
    return state.media.isWebi;
  },
  getSignedUri: function getSignedUri(state, key) {
    return state.media.signedUris[key];
  },
  isRecording: function isRecording(state) {
    return state.media.isRecording;
  },
  contentFont: function contentFont(state) {
    return state.media.contentFont;
  }
};